import { render, staticRenderFns } from "./RatingCategoriesEditor.vue?vue&type=template&id=180e28f6&scoped=true&"
import script from "./RatingCategoriesEditor.vue?vue&type=script&lang=js&"
export * from "./RatingCategoriesEditor.vue?vue&type=script&lang=js&"
import style0 from "./RatingCategoriesEditor.vue?vue&type=style&index=0&id=180e28f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180e28f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
